<template>
  <div class="publications-by-source-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <bar-chart
      v-if="isLoaded"
      :chart-data="dataBarCollection"
      :options="barOptions"
      class="publications-by-source-content__chart"
      :height="250"
    ></bar-chart>

    <div class="axes-title">
      {{$t('feed.analytics.tonalComment.body.axesTitle')}}
    </div>

    <div class="chart-footer">
      <ul class="tonal-list" v-if="Object.keys(dataBarCollection).length">
        <li v-for="(item, index) in tonal" :class="`tonal-list__item tonal-list__item--${item.name}`" :key="index">
          {{item.title}}
        </li>
      </ul>

      <!--<el-checkbox v-model="showZeroData" data-html2canvas-ignore="true">Нулевые данные</el-checkbox>-->
    </div>
    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.analytics.tonalComment.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { BarChart } from "../../../../../../../../components/charts";

  // actions
  import {SWITCH_ZERO} from "../../../../../../../../store/actions/analytics";

  // mixins
  import tonalComment from "../../../../../../../../mixins/chart/tonalComment";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import tonal from "../../../../../../../../config/tonals";

  // moment
  import moment from 'moment';

  export default {
    name: "PublicationsBySourceBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        tonal: this.$t('feed.analytics.tonalComment.body.tonal'),
        chartId: "TonalComment",
        format: "DD.MM.YYYY",
        showLabel: true,
        tonalItems: {
          netural: {
            name: 'netural',
            title: this.$t('feed.analytics.tonalComment.body.tonal[0].title'),
            position: "top",
            backgroundColor: "#b3bccc",
            borderColor: "rgba(0, 0, 0, 0)",
          },
          positive: {
            name: 'positive',
            title: this.$t('feed.analytics.tonalComment.body.tonal[1].title'),
            position: "bottom",
            backgroundColor: "#15cf49",
            borderColor: "rgba(0, 0, 0, 0)",
          },
          negative: {
            name: 'negative',
            title: this.$t('feed.analytics.tonalComment.body.tonal[2].title'),
            position: "top",
            backgroundColor: "#f75b5b",
            borderColor: "rgba(0, 0, 0, 0)",
          }
        },
        tonalArr: [],
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      showZeroData: {
        get() {
          return this.$store.getters.getZeroData(this.chartName);
        },
        set(value) {
          this.$store.dispatch(SWITCH_ZERO, {chart: this.chartName, isZero: value})
        }
      },
      chartDate() {
        return this.$store.getters.getPeriod(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
      isLoaded() {
        return this.$store.getters.isLoaded(this.chartName);
      }
    },
    mixins: [
      tonalComment,
      saveImage
    ],
    components: {
      BarChart
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .publications-by-source-content__chart {
    margin-bottom: 10px;
  }

  .axes-title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    padding: 0 0 10px 0;
    color: #5E6D82;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
